// extracted by mini-css-extract-plugin
export default {"success-icon-style":"SuccessIcon_success-icon-style__FSPun"};